// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from "@/store/store";


import {
  sync
} from "vuex-router-sync";


// todo
// cssVars()

Vue.use(BootstrapVue)

import IdleVue from 'idle-vue'
const eventsHub = new Vue();

// import { LoaderPlugin } from 'vue-google-login';
// Vue.use(LoaderPlugin, {
//   client_id: "225788483142-8pkg8on8nh60ao83ve33ff3lflv2ccvo.apps.googleusercontent.com"
// });
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 10000,
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
